// msmeindexData.js

// CLUSTER 1: FINANCIAL ARCHITECTURE & CAPITAL STABILITY
const baseQuestionsFinancialArchitecture = [
  // 🔹 Limited Access to Finance
  { id: "fa1q1", label: "We maintain updated financial statements ready for loan or investor review.", pillar: "Finance" },
  { id: "fa1q2", label: "We have applied for formal bank/NBFC credit in the last 2 years.", pillar: "Finance" },
  { id: "fa1q3", label: "We understand eligibility criteria for major MSME loan schemes.", pillar: "Finance" },
  { id: "fa1q4", label: "We prepare cash flow projections before approaching lenders.", pillar: "Finance" },
  { id: "fa1q5", label: "We maintain a structured credit-readiness file (documents, ratios, projections).", pillar: "Finance" },

  // 🔹 High Cost of Credit
  { id: "fa2q1", label: "We compare interest rates and loan terms before borrowing.", pillar: "Finance" },
  { id: "fa2q2", label: "We calculate the effective annual cost (including fees and penalties) of loans.", pillar: "Finance" },
  { id: "fa2q3", label: "We assess ROI before taking working capital or term loans.", pillar: "Finance" },
  { id: "fa2q4", label: "We actively work to improve our credit rating or bank profile.", pillar: "Finance" },
  { id: "fa2q5", label: "We renegotiate or refinance loans when better terms are available.", pillar: "Finance" },

  // 🔹 Delayed Payments & Receivable Stress
  { id: "fa3q1", label: "We track receivables ageing (30/60/90 days) regularly.", pillar: "Finance" },
  { id: "fa3q2", label: "We have defined payment terms in written contracts or invoices.", pillar: "Finance" },
  { id: "fa3q3", label: "We follow a structured reminder/escalation process for overdue payments.", pillar: "Finance" },
  { id: "fa3q4", label: "We use digital tools or TReDS platforms to manage receivables.", pillar: "Finance" },
  { id: "fa3q5", label: "Delayed payments rarely disrupt our operations or payroll.", pillar: "Finance" },

  // 🔹 Overdependence on Informal Credit
  { id: "fa4q1", label: "Less than 25% of our working capital comes from informal lenders.", pillar: "Finance" },
  { id: "fa4q2", label: "We have an active relationship with at least one formal financial institution.", pillar: "Finance" },
  { id: "fa4q3", label: "We understand the long-term cost difference between formal and informal credit.", pillar: "Finance" },
  { id: "fa4q4", label: "We have a plan to gradually replace informal borrowing with formal finance.", pillar: "Finance" },
  { id: "fa4q5", label: "We avoid taking emergency high-interest loans for routine expenses.", pillar: "Finance" },

  // 🔹 Weak Financial Literacy & Planning
  { id: "fa5q1", label: "We prepare annual budgets and review them periodically.", pillar: "Finance" },
  { id: "fa5q2", label: "We monitor profit margins by product/service line.", pillar: "Finance" },
  { id: "fa5q3", label: "We maintain cost sheets and understand unit economics.", pillar: "Finance" },
  { id: "fa5q4", label: "We forecast cash flow for at least the next 3–6 months.", pillar: "Finance" },
  { id: "fa5q5", label: "Financial decisions are based on data rather than intuition alone.", pillar: "Finance" },

];

// CLUSTER 2: GOVERNANCE & DECISION SYSTEMS
const baseQuestionsGovernanceSystems = [
  // 🔹 Business Professionalization Gaps
  { id: "gs1q1", label: "Roles and responsibilities are clearly defined and documented in our business.", pillar: "Governance" },
  { id: "gs1q2", label: "Major business decisions follow a structured review process, not just owner judgment.", pillar: "Governance" },
  { id: "gs1q3", label: "We conduct periodic management or strategy review meetings.", pillar: "Governance" },
  { id: "gs1q4", label: "Key performance indicators (KPIs) are defined and monitored regularly.", pillar: "Governance" },
  { id: "gs1q5", label: "Business continuity is possible even if the owner is temporarily unavailable.", pillar: "Governance" },

  // 🔹 Informality & Registration Issues
  { id: "gs2q1", label: "Our business is formally registered under applicable MSME/Udyam registration.", pillar: "Governance" },
  { id: "gs2q2", label: "We maintain all required licenses and registrations updated.", pillar: "Governance" },
  { id: "gs2q3", label: "We file statutory returns (GST, income tax, etc.) on time.", pillar: "Governance" },
  { id: "gs2q4", label: "We maintain proper documentation for contracts, employees, and vendors.", pillar: "Governance" },
  { id: "gs2q5", label: "We understand the benefits of operating fully within the formal ecosystem.", pillar: "Governance" },

  // 🔹 Regulatory & Compliance Burden
  { id: "gs3q1", label: "We track all regulatory requirements applicable to our sector.", pillar: "Governance" },
  { id: "gs3q2", label: "Compliance responsibilities are clearly assigned to a person or consultant.", pillar: "Governance" },
  { id: "gs3q3", label: "We maintain a compliance calendar for filings and renewals.", pillar: "Governance" },
  { id: "gs3q4", label: "We proactively prepare for inspections or audits.", pillar: "Governance" },
  { id: "gs3q5", label: "Compliance costs and risks are reviewed during financial planning.", pillar: "Governance" },

  // 🔹 Lack of Awareness of Government Schemes
  { id: "gs4q1", label: "We actively monitor new MSME-related government schemes and policies.", pillar: "Governance" },
  { id: "gs4q2", label: "We have applied for at least one government support scheme in the last 2 years.", pillar: "Governance" },
  { id: "gs4q3", label: "We understand eligibility criteria for major MSME schemes (CGTMSE, TReDS, ZED, etc.).", pillar: "Governance" },
  { id: "gs4q4", label: "We evaluate scheme benefits before making investment decisions.", pillar: "Governance" },
  { id: "gs4q5", label: "We maintain documentation readiness for availing government incentives.", pillar: "Governance" },

  // 🔹 Corruption & Uneven Policy Implementation Navigation
  { id: "gs5q1", label: "We follow transparent processes in all regulatory and official interactions.", pillar: "Governance" },
  { id: "gs5q2", label: "We avoid informal payments or shortcuts to resolve compliance matters.", pillar: "Governance" },
  { id: "gs5q3", label: "We escalate policy-related grievances through formal mechanisms when required.", pillar: "Governance" },
  { id: "gs5q4", label: "We maintain proper documentation to protect against arbitrary enforcement.", pillar: "Governance" },
  { id: "gs5q5", label: "We seek professional or legal advice when facing regulatory uncertainty.", pillar: "Governance" },

];

// CLUSTER 3: MARKET & COMPETITIVE POSITIONING
const baseQuestionsMarketPositioning = [
  // 🔹 Limited Market Access
  { id: "mp1q1", label: "We sell through multiple channels (offline, online, distributor, direct, etc.).", pillar: "Market" },
  { id: "mp1q2", label: "We actively explore new geographic or sector markets annually.", pillar: "Market" },
  { id: "mp1q3", label: "We participate in trade fairs, B2B platforms, or industry networks.", pillar: "Market" },
  { id: "mp1q4", label: "We track market demand trends relevant to our products/services.", pillar: "Market" },
  { id: "mp1q5", label: "A single customer does not account for more than 30% of our revenue.", pillar: "Market" },

  // 🔹 Branding & Marketing Challenges
  { id: "mp2q1", label: "We have a clearly defined brand identity and value proposition.", pillar: "Market" },
  { id: "mp2q2", label: "We maintain a professional digital presence (website, social media, listings).", pillar: "Market" },
  { id: "mp2q3", label: "We allocate a defined budget for marketing and promotion.", pillar: "Market" },
  { id: "mp2q4", label: "We track marketing performance metrics (leads, conversions, engagement).", pillar: "Market" },
  { id: "mp2q5", label: "Our brand messaging is consistent across all customer touchpoints.", pillar: "Market" },

  // 🔹 Sales & Customer Acquisition Inconsistency
  { id: "mp3q1", label: "We maintain a structured sales pipeline or CRM system.", pillar: "Market" },
  { id: "mp3q2", label: "Monthly sales targets are defined and reviewed.", pillar: "Market" },
  { id: "mp3q3", label: "Customer acquisition strategies are documented and repeatable.", pillar: "Market" },
  { id: "mp3q4", label: "We analyse reasons for lost deals or declining sales.", pillar: "Market" },
  { id: "mp3q5", label: "Revenue inflow is predictable rather than highly volatile.", pillar: "Market" },

  // 🔹 Competitive Pressure from Large Firms
  { id: "mp4q1", label: "We clearly differentiate our offerings from larger competitors.", pillar: "Market" },
  { id: "mp4q2", label: "We regularly benchmark our pricing and value proposition against competitors.", pillar: "Market" },
  { id: "mp4q3", label: "We focus on niche markets or specialized segments to reduce direct competition.", pillar: "Market" },
  { id: "mp4q4", label: "We maintain strong customer relationships that reduce price-based switching.", pillar: "Market" },
  { id: "mp4q5", label: "We innovate products/services periodically to maintain competitiveness.", pillar: "Market" },

  // 🔹 Regional Market Disparities
  { id: "mp5q1", label: "We assess regional demand differences before expanding into new areas.", pillar: "Market" },
  { id: "mp5q2", label: "We adapt pricing or strategy based on local market conditions.", pillar: "Market" },
  { id: "mp5q3", label: "We leverage digital platforms to overcome geographic limitations.", pillar: "Market" },
  { id: "mp5q4", label: "We monitor state-level policies or incentives affecting our market access.", pillar: "Market" },
  { id: "mp5q5", label: "Revenue is not heavily dependent on a single region.", pillar: "Market" },

];

// CLUSTER 4: OPERATIONAL FLOW & PRODUCTIVITY SYSTEMS
const baseQuestionsOperationalFlow = [
  // 🔹 Inventory Inefficiencies
  { id: "of1q1", label: "We track inventory levels regularly using a defined system.", pillar: "Operations" },
  { id: "of1q2", label: "We analyse slow-moving or dead stock periodically.", pillar: "Operations" },
  { id: "of1q3", label: "Reorder levels are defined based on demand patterns.", pillar: "Operations" },
  { id: "of1q4", label: "Inventory data is reconciled with physical stock at scheduled intervals.", pillar: "Operations" },
  { id: "of1q5", label: "Inventory holding costs are monitored and reviewed.", pillar: "Operations" },

  // 🔹 Logistics & Supply Chain Constraints
  { id: "of2q1", label: "We have multiple supplier options to reduce dependency risk.", pillar: "Operations" },
  { id: "of2q2", label: "Delivery timelines are tracked and reviewed for consistency.", pillar: "Operations" },
  { id: "of2q3", label: "We monitor logistics costs as a percentage of revenue.", pillar: "Operations" },
  { id: "of2q4", label: "Supply disruptions are documented and analysed for prevention.", pillar: "Operations" },
  { id: "of2q5", label: "We maintain safety stock or contingency sourcing plans.", pillar: "Operations" },

  // 🔹 Infrastructure Limitations
  { id: "of3q1", label: "Power, internet, or utility disruptions rarely affect our operations.", pillar: "Operations" },
  { id: "of3q2", label: "We have backup arrangements for critical infrastructure (power, data, etc.).", pillar: "Operations" },
  { id: "of3q3", label: "Production capacity is reviewed against demand forecasts.", pillar: "Operations" },
  { id: "of3q4", label: "We invest periodically in upgrading equipment or facilities.", pillar: "Operations" },
  { id: "of3q5", label: "Infrastructure constraints are considered during strategic planning.", pillar: "Operations" },

  // 🔹 Technology Adoption Barriers
  { id: "of4q1", label: "We evaluate new technologies before making major operational investments.", pillar: "Operations" },
  { id: "of4q2", label: "Employees are trained when new tools or systems are introduced.", pillar: "Operations" },
  { id: "of4q3", label: "We calculate ROI before adopting new machinery or software.", pillar: "Operations" },
  { id: "of4q4", label: "Resistance to new technology is addressed through structured change management.", pillar: "Operations" },
  { id: "of4q5", label: "Technology upgrades are aligned with long-term business goals.", pillar: "Operations" },

  // 🔹 Data Systems & ERP Underutilization
  { id: "of5q1", label: "We use ERP/MIS systems to integrate finance, inventory, and sales data.", pillar: "Operations" },
  { id: "of5q2", label: "Reports from digital systems are reviewed for decision-making.", pillar: "Operations" },
  { id: "of5q3", label: "Data entry is timely and accurate across departments.", pillar: "Operations" },
  { id: "of5q4", label: "We use dashboards or analytics tools to monitor operational KPIs.", pillar: "Operations" },
  { id: "of5q5", label: "System-generated insights influence cost or efficiency improvements.", pillar: "Operations" },

];

// CLUSTER 5: STRATEGIC RESILIENCE & FUTURE READINESS
const baseQuestionsStrategicResilience = [
  // 🔹 Skilled Workforce Shortage
  { id: "sr1q1", label: "We face difficulty in hiring skilled employees for critical roles.", pillar: "Strategy" },
  { id: "sr1q2", label: "We have defined skill requirements for each key position.", pillar: "Strategy" },
  { id: "sr1q3", label: "We collaborate with training institutes or skill programs when needed.", pillar: "Strategy" },
  { id: "sr1q4", label: "Skill gaps are periodically assessed within the organization.", pillar: "Strategy" },
  { id: "sr1q5", label: "We invest in upskilling employees to reduce dependency on external hiring.", pillar: "Strategy" },

  // 🔹 Talent Retention Challenges
  { id: "sr2q1", label: "Employee turnover affects our operational continuity.", pillar: "Strategy" },
  { id: "sr2q2", label: "We have defined career progression pathways for employees.", pillar: "Strategy" },
  { id: "sr2q3", label: "Compensation structures are benchmarked against market standards.", pillar: "Strategy" },
  { id: "sr2q4", label: "We conduct periodic employee feedback or satisfaction reviews.", pillar: "Strategy" },
  { id: "sr2q5", label: "Retention risks are discussed during management reviews.", pillar: "Strategy" },

  // 🔹 Certification & Quality Standard Compliance
  { id: "sr3q1", label: "We maintain industry-relevant certifications (ISO, FSSAI, etc.) where applicable.", pillar: "Strategy" },
  { id: "sr3q2", label: "Compliance requirements are reviewed periodically.", pillar: "Strategy" },
  { id: "sr3q3", label: "Quality audits are conducted internally or externally.", pillar: "Strategy" },
  { id: "sr3q4", label: "Non-compliance risks are documented and corrected promptly.", pillar: "Strategy" },
  { id: "sr3q5", label: "Certifications are used strategically to improve market positioning.", pillar: "Strategy" },

  // 🔹 Sustainability & Green Transition Readiness
  { id: "sr4q1", label: "We track energy, water, or resource consumption patterns.", pillar: "Strategy" },
  { id: "sr4q2", label: "Waste reduction or recycling initiatives are implemented.", pillar: "Strategy" },
  { id: "sr4q3", label: "We evaluate environmentally friendly alternatives in sourcing or production.", pillar: "Strategy" },
  { id: "sr4q4", label: "Sustainability compliance requirements are monitored.", pillar: "Strategy" },
  { id: "sr4q5", label: "Green transition is considered in long-term strategic planning.", pillar: "Strategy" },

  // 🔹 Exposure to Macro Risks (Trade, Commodity Volatility)
  { id: "sr5q1", label: "We monitor commodity price fluctuations relevant to our business.", pillar: "Strategy" },
  { id: "sr5q2", label: "We assess impact of policy or trade changes on our operations.", pillar: "Strategy" },
  { id: "sr5q3", label: "Revenue diversification reduces dependence on a single product or market.", pillar: "Strategy" },
  { id: "sr5q4", label: "We maintain financial buffers to handle economic downturns.", pillar: "Strategy" },
  { id: "sr5q5", label: "Scenario planning is conducted for major external risks.", pillar: "Strategy" },

];

export const allSets = {
  1: baseQuestionsFinancialArchitecture,
  2: baseQuestionsGovernanceSystems,
  3: baseQuestionsMarketPositioning,
  4: baseQuestionsOperationalFlow,
  5: baseQuestionsStrategicResilience,
};
